module.exports = __webpack_public_path__ + "img/icon_60px_1_blue.7fcbfb15.svg";